import { render } from "./CategoriesMenu.vue?vue&type=template&id=39388794"
import script from "./CategoriesMenu.js?vue&type=script&lang=js"
export * from "./CategoriesMenu.js?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./CategoriesMenu.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2Fcomponents%2FCategoriesMenu%2FdefaultMenu%2FCategoriesMenu.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__